import { SimpleMdeReact } from "react-simplemde-editor";
import styled from "styled-components";
import { DialogTitle as UIDialogTitle } from "@evergis/ui";
import { DnDAnchor, ListItem } from "../../../../../modules/LayerList/styled";
import { DraggableList } from "../../../../DraggableList/DraggableList";
import { DialogTitle } from "../../../DialogComponents/DialogTitle";
import { DialogContent, RestrictedWidthContainer } from "../../../DialogComponents/styled";

export const ProjectInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 56rem;
`;

export const StyledDraggableList = styled(DraggableList)`
  display: flex;
  flex-direction: column;
`;

export const DeleteContainer = styled.div`
  position: relative;
  margin-left: 0.5rem;
  margin-top: 0.5rem;
  flex-shrink: 0;
  visibility: hidden;
`;

export const StyledDndAnchor = styled(DnDAnchor)`
  height: auto;
  position: relative;
  margin-right: 0.5rem;
  margin-top: 0.5rem;
  flex-shrink: 0;
  visibility: hidden;
`;

export const InfoBlock = styled(ListItem)`
  overflow: visible;
  flex-direction: row;
  align-items: start;
  width: 100%;

  &:hover {
    ${DeleteContainer}, ${StyledDndAnchor} {
      visibility: visible;
    }
  }
`;

export const GalleryContainer = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid ${({ theme }) => theme.palette.elementDeep};
  gap: 0.75rem 0;
  padding: 1rem;
  border-radius: 4px;
  width: 100%;
`;

export const GalleryContainerHeader = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
`;

export const GalleryContainerSettings = styled.div`
  display: flex;
  margin-left: auto;
  gap: 0 1.5rem;

  input {
    margin-left: 0 !important;
  }
`;

export const GallerySetting = styled.div`
  display: flex;
  gap: 0 0.5rem;
  align-items: center;
`;

export const GallerySettingsLabel = styled.label`
  font-size: 12px;
  color: ${({ theme }) => theme.palette.textSecondary};
`;

export const AddBlock = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  position: relative;
  visibility: hidden;
`;

export const StyledMarkdownEditor = styled(SimpleMdeReact)`
  width: 100%;

  .CodeMirror {
    background-color: ${({ theme }) => theme.palette.background};
    border-color: ${({ theme }) => theme.palette.elementDeep} !important;
    color: ${({ theme }) => theme.palette.textPrimary};
  }

  .editor-toolbar {
    border-color: ${({ theme }) => theme.palette.elementDeep} !important;
  }

  .editor-toolbar i.fa:before {
    color: ${({ theme }) => theme.palette.icon};
  }

  .editor-toolbar button.active,
  .editor-toolbar button:hover {
    border-color: ${({ theme }) => theme.palette.elementDeep} !important;
    background-color: ${({ theme }) => theme.palette.element};
  }

  .editor-toolbar .separator {
    border-color: ${({ theme }) => theme.palette.elementDeep} !important;
  }
`;

export const StyledDialogContent = styled(DialogContent)`
  padding: 0;
`;

export const StyledDialogTitle = styled(DialogTitle)`
  ${UIDialogTitle} {
    padding: 3rem 3rem 0;
  }

  ${RestrictedWidthContainer} {
    width: auto;
  }
`;
